import React, { useMemo } from 'react'
import ArticleField from '../ArticleField';
import { Grid, TextField, Checkbox } from '@material-ui/core';

interface TitleProps {
    value: string,
    onChange: (value: string) => void
}

const remove_italics = (value: string) => value.replace("<em>", "").replace("</em>", "");

const add_italics = (value: string) => `<em>${value}</em>`;

const Title = (props: TitleProps) => {
    const italics = useMemo(() => props.value.startsWith("<em>"), [props.value]);
    const text = useMemo(() => remove_italics(props.value), [props.value]);

    return <ArticleField>
        <TextField
            inputProps={{ maxLength: 256 }}
            fullWidth={true} 
            required
            label="Titre"
            value={text}
            onChange={(e) => {
                if (italics) {
                    props.onChange(add_italics(e.target.value));
                } else {
                    props.onChange(e.target.value);
                }
        }}/>
        <Grid container justify="space-between">
            <Grid item>
                {props.value.length}/256
            </Grid>
            <Grid item>
                <Checkbox
                    checked={italics}
                    onChange={(event) => {
                        if (event.target.checked) {
                            props.onChange(add_italics(props.value));
                        } else {
                            props.onChange(remove_italics(props.value));
                        }
                    }}
                />
                Italique
            </Grid>
        </Grid>
        
    </ArticleField>
};

export default Title;